import React, { useRef } from 'react'
import DownloadTable from './DownloadTable';
import ListaLinhaValorDestacado from './ListaLinhaValorDestacado';
import { Link } from 'react-router-dom';

export default function ListaIndices(props) {
    const tableRef = useRef();

    return (
        <>
            <DownloadTable tableRef={tableRef} template={props.valores[0]} />
            <table ref={tableRef} className="table  table-sm small table-hover" id="table_indices">

                <thead>
                    <tr>
                        <th>CRITÉRIOS</th>
                        <th>PESO</th>
                        <th>FONTE</th>
                        <th>PERIODICIDADE</th>
                        {/* <th>UNIDADE</th> */}
                        <th className="text-right">PERCENTUAL (%)</th>
                    </tr></thead>
                <tbody>
                    {props.valores.map(valor => {
                        return <tr key={Math.random()}>
                            <td className="">
                                <ListaLinhaValorDestacado valor={valor.nome} destacado={valor.destacado} cor={'#E26B64'} />
                            </td>
                            <td className=""> <span style={{ fontSize: '11px' }} >{valor.descricao} </span></td>
                            <td className=""> <Link to={'/parceiros'} style={{ color: 'black', textDecoration: 'none' }}> <small>{valor.fontes}</small> </Link> </td>
                            <td className=""> {valor.periodicidade} </td>
                            <td className="text-right"> {valor.valor} </td>
                        </tr>
                    })}
                </tbody>
            </table>
        </>
    )
}

